var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-content',[_c('h1',{staticClass:"text-center primary--text pt-4"},[_vm._v("\n      Nutzerverwaltung\n    ")])]),_c('v-row',{attrs:{"cols":"12"}},[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('UserTable')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }